import { PrismicError } from "./PrismicError.js";
class ForbiddenError extends PrismicError {}
export { ForbiddenError };
